import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AdminPage = () => {
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ uid: '', email: '', is_admin: false });
  const [loading, setLoading] = useState(true);

  const API_BASE = process.env.REACT_APP_BACKEND_URL;

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/admin/users`);
      setUsers(res.data.users);
    } catch (err) {
      console.error('Error fetching users', err);
    } finally {
      setLoading(false);
    }
  };

  const createUser = async () => {
    try {
      await axios.post(`${API_BASE}/api/admin/users`, newUser);
      setNewUser({ uid: '', email: '', is_admin: false });
      fetchUsers();
    } catch (err) {
      alert('Failed to create user');
    }
  };

  const deleteUser = async (uid) => {
    if (!window.confirm('Are you sure you want to delete this user?')) return;
    try {
      await axios.delete(`${API_BASE}/api/admin/users/${uid}`);
      fetchUsers();
    } catch (err) {
      alert('Delete failed');
    }
  };

  const toggleStatus = async (uid, currentStatus) => {
    const newStatus = currentStatus === 'disabled' ? 'active' : 'disabled';
    try {
      await axios.patch(`${API_BASE}/api/admin/users/${uid}`, { status: newStatus });
      fetchUsers();
    } catch (err) {
      alert('Status update failed');
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-6">Admin Panel</h1>

      <div className="mb-6 bg-gray-100 p-4 rounded">
        <h2 className="text-lg font-semibold mb-2">Create New User</h2>
        <input
          placeholder="UID"
          className="border p-2 mr-2"
          value={newUser.uid}
          onChange={(e) => setNewUser({ ...newUser, uid: e.target.value })}
        />
        <input
          placeholder="Email"
          className="border p-2 mr-2"
          value={newUser.email}
          onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
        />
        <input
          placeholder="Password"
          type="password"
          className="border p-2 mr-2"
          value={newUser.password || ''}
          onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
        />
        <label className="mr-2">
          <input
            type="checkbox"
            checked={newUser.is_admin}
            onChange={(e) => setNewUser({ ...newUser, is_admin: e.target.checked })}
          /> Admin
        </label>
        <button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={createUser}>
          Create
        </button>
      </div>

      <div className="bg-white shadow p-4 rounded">
        <h2 className="text-lg font-semibold mb-4">All Users</h2>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <table className="w-full table-auto text-left border-collapse">
            <thead>
              <tr>
                <th className="border p-2">UID</th>
                <th className="border p-2">Email</th>
                <th className="border p-2">Role</th>
                <th className="border p-2">Status</th>
                <th className="border p-2">Payment</th>
                <th className="border p-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.uid}>
                  <td className="border p-2">{user.uid}</td>
                  <td className="border p-2">{user.email || 'N/A'}</td>
                  <td className="border p-2">{user.role || 'user'}</td>
                  <td className="border p-2">{user.status || 'active'}</td>
                  <td className="border p-2">
                    {user.payment_status === 'paid' ? (
                      <span className="text-green-600 font-semibold">Paid</span>
                    ) : (
                      <span className="text-red-600 font-semibold">Unpaid</span>
                    )}
                  </td>
                  <td className="border p-2 space-x-2">
                    <button className="text-red-600" onClick={() => deleteUser(user.uid)}>Delete</button>
                    <button className="text-blue-600" onClick={() => toggleStatus(user.uid, user.status)}>
                      {user.status === 'disabled' ? 'Enable' : 'Disable'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminPage;
